"use strict";

export function initInScope ($scope) {


}